<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<div class="full-width">
  <div class="user-list-container mat-elevation-z8">
    <mat-toolbar class="background">
      <mat-toolbar-row>
        <mat-icon class="mdi-24px" fontIcon="mdi-account-multiple"></mat-icon>
        <p>Users</p>
      </mat-toolbar-row>
      <mat-toolbar-row>
        <mat-form-field class="w-50">
          <input matInput [formControl]="filterControl" placeholder="Search" autocomplete="off" />
          @if (filterControl.value) {
          <button mat-icon-button matSuffix (click)="clearFilter()" title="Clear Search">
            <mat-icon style="transform: scale(0.85)" fontIcon="mdi-close-circle-outline"></mat-icon>
          </button>
          }
        </mat-form-field>
        <mat-paginator #userPaginator [pageSizeOptions]="[10, 25, 50, 100]" aria-label="Select page of users"></mat-paginator>
      </mat-toolbar-row>
    </mat-toolbar>

    <mat-table class="table-all-users" #table [dataSource]="userDataSource" matSort
      (matSortChange)="onSortChange($event)">
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>User Name</mat-header-cell>
        <mat-cell *matCellDef="let element">
          @if (element.name !== null) {
          <div>{{ element.name }}</div>
          }
          @if (element.name === null) {
          <div>{{ element.id }}</div>
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div>
            @if (!onAnotherTeam(element.id) && canEditMsel()) {
            <button mat-icon-button (click)="addUserToTeam(element)" style="outline: none;"
              title="Add {{ element.name }} to Team">
              <mat-icon class="mdi-24px self-center" fontIcon="mdi-plus-circle-outline"></mat-icon>
            </button>
            }
            @if (onAnotherTeam(element.id)) {
            <label>{{ getUserTeamName(element.id) }}</label>
            }
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="minUserColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: minUserColumns"></mat-row>
    </mat-table>

    @if (userDataSource.filteredData.length === 0) {
    <div>No results found</div>
    }
  </div>

  <div class="spacer">&nbsp;</div>

  @if (teamList) {
  <div class="team-list-container mat-elevation-z8">
    <mat-toolbar class="background">
      <mat-toolbar-row>
        <mat-icon class="mdi-24px" fontIcon="mdi-account-group"></mat-icon>
        <p>Team Members</p>
      </mat-toolbar-row>
      <mat-toolbar-row>
        <mat-form-field class="w-50">
          <input matInput [formControl]="teamMemberFilterControl" placeholder="Search" autocomplete="off" />
          @if (teamMemberFilterControl.value) {
          <button mat-icon-button matSuffix (click)="clearTeamMemberFilter()" title="Clear Search">
            <mat-icon style="transform: scale(0.85)" fontIcon="mdi-close-circle-outline"></mat-icon>
          </button>
          }
        </mat-form-field>
        <mat-paginator #teamMemberPaginator [pageSizeOptions]="[10, 25, 50, 100]" aria-label="Select page of team members"></mat-paginator>
      </mat-toolbar-row>
    </mat-toolbar>

    <mat-table class="table-all-users" #table [dataSource]="teamUserDataSource" matSort
      (matSortChange)="onSortTeamChange($event)">
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>User Name</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div>{{ getUserName(element.userId) }}</div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="type">
        <mat-header-cell *matHeaderCellDef>Type</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-select [value]="getUserTeamRole(element.userId)" (selectionChange)="setUserTeamRole(element.userId, element.teamId, $event.value)" [disabled]="!canEditMsel()">
            <mat-option value="">-- None --</mat-option>
            @for (role of teamRoles; track role) {
            <mat-option [value]="role">{{ role }}</mat-option>
            }
          </mat-select>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div>
            @if (canEditMsel()) {
            <button mat-icon-button (click)="removeUserFromTeam(element)" style="outline: none;"
              title="Remove {{ element.name }} from Team">
              <mat-icon class="mdi-24px self-center" fontIcon="mdi-minus-circle-outline"></mat-icon>
            </button>
            }
          </div>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedTeamUserColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedTeamUserColumns"></mat-row>
    </mat-table>
  </div>
  }

</div>
